import { Label } from '@primer/react';
import { StarIcon, CopilotIcon } from '@primer/octicons-react';
import { PropTableValues } from "../../../../src/components";
import { EyebrowBannerIconColors, EyebrowBannerLabelColors } from '@primer/react-brand';
import * as React from 'react';
export default {
  Label,
  StarIcon,
  CopilotIcon,
  PropTableValues,
  EyebrowBannerIconColors,
  EyebrowBannerLabelColors,
  React
};